"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 *
 * Remove widows from strings on a page, client-side.
 *
 * First the function parses select html elements on a page
 * Then it breaks that into words and counts the length of the string in words
 * Then it counts the length of the last three words and applies either
 * a three word widow break if the words are small enough
 * or a two word widow break if the words are longer
 * but only if the total string length is at least the minimum number of words
 *
 * @param {object} [config={
    minWords: 4,
    maxLastWordLength: 9,
    maxPenultWordLength: 4,
    maxAntepenultWordLength: 5,
    maxLastWordLengthTwo: 13,
    maxPenultWordLengthTwo: 11,
  }] the config object
 * @returns
 */


var unWidowerClient = function unWidowerClient(config) {
  // make sure there is a window in case this was included SSR
  // otherwise show a warning
  if (typeof window !== "undefined") {
    var defaultConfig = {
      minWords: 4,
      maxLastWordLength: 9,
      // defaults for three-word widow breaker
      maxPenultWordLength: 4,
      // defaults for three-word widow breaker
      maxAntepenultWordLength: 5,
      // defaults for two-word widow-breaker
      maxLastWordLengthTwo: 13,
      // defaults for two-word widow-breaker
      maxPenultWordLengthTwo: 11
    }; // merge passed config with default

    var _defaultConfig$config = _objectSpread({}, defaultConfig, {}, config),
        minWords = _defaultConfig$config.minWords,
        maxLastWordLength = _defaultConfig$config.maxLastWordLength,
        maxPenultWordLength = _defaultConfig$config.maxPenultWordLength,
        maxAntepenultWordLength = _defaultConfig$config.maxAntepenultWordLength,
        maxLastWordLengthTwo = _defaultConfig$config.maxLastWordLengthTwo,
        maxPenultWordLengthTwo = _defaultConfig$config.maxPenultWordLengthTwo; // document is grabbed from client
    // eslint-disable-next-line no-undef


    document // loop through elements containing text
    .querySelectorAll("h1,h2,h3,h4,h5,p,blockquote,li,ol,span").forEach(function (el) {
      var element = el;

      if (element.innerHTML.length > 0) {
        var copy = element.innerHTML.split(" "); // if copy is at least minimum number of words

        if (copy.length >= minWords) {
          var lastword = copy[copy.length - 1];
          var penultword = copy[copy.length - 2];
          var antepenultword = copy[copy.length - 3];

          if ( // replace last two breaking spaces with nbsps if the words are short enough
          // this helps prevent pseudo-widows where the last two words on a line are short
          // enough to look like a widow
          lastword.length < maxLastWordLength && penultword.length < maxPenultWordLength && antepenultword.length < maxAntepenultWordLength) {
            element.innerHTML = el.innerHTML.replace(/ (?=[^ ]*$)/i, "\xA0").replace(/ (?=[^ ]*$)/i, "\xA0");
          } else if ( // otherwise, just create an nbsp between the last two words,
          // assuming that they're also short enough
          lastword.length < maxLastWordLengthTwo && penultword.length < maxPenultWordLengthTwo) {
            // replace last breaking space with a nbsp
            element.innerHTML = el.innerHTML.replace(/ (?=[^ ]*$)/i, "\xA0");
          }
        }
      }
    });
  } else {
    // Warn developers if they're using this in the wrong context.
    // eslint-disable-next-line no-console
    console.warn("unWidowerClient is only intended for client-side use. Check the README for more info. If this script is run again client-side, you can ignore this message.");
  }
};

var _default = unWidowerClient;
exports["default"] = _default;